import * as React from 'react';
import { style } from 'typestyle';
import Renderer from 'src/utils/Domain/Renderer';
import { ConfigurableGridConfigItem } from 'src/components/ConfigurableGrid/ConfigurableGrid.types';
import { ICellEditorParams } from '@ag-grid-community/core';
import { isNil, isString } from 'lodash';

const statusClass = style({
  $debugName: 'status-icon-renderer',
  marginLeft: '5px',
  marginRight: '7px',
});

export interface StatusIconRendererParams {
  innerRenderer?: string;
  iconDataIndex?: string;
  iconPosition?: 'left' | 'right';
}

export interface Params {
  value?: string;
  rendererParams?: StatusIconRendererParams;
}

export interface GridParams extends ICellEditorParams {
  rendererParams?: StatusIconRendererParams;
}

export class GridStatusIconRenderer extends React.Component<GridParams> {
  render() {
    const { value, rendererParams, node, api } = this.props;
    const { innerRenderer, iconDataIndex, iconPosition } = rendererParams ?? {};
    let iconElement = <></>;
    let iconTuple: string[] = [];
    let textStr: string | undefined | null = undefined;
    // If iconDataIndex is populated, fetch the tuple from that cell in the grid rather than current
    // Instead, current (`value`) is what is shown *next* to the icon, rather than than the text coming from
    // within the tuple.
    if (!isNil(iconDataIndex)) {
      let iconStr = api.getValue(iconDataIndex, node);
      iconTuple = iconStr && isString(iconStr) ? iconStr.split(',') : [];
      textStr = value;
    } else {
      let iconStr = value;
      iconTuple = iconStr && isString(iconStr) ? iconStr.split(',') : [];
      textStr = iconTuple.length >= 3 ? iconTuple[2] : '';
    }
    if (iconTuple.length >= 2) {
      iconElement = <i className={`${statusClass} fa-fw ${iconTuple[0]}`} style={{ color: iconTuple[1] }} />;
    }

    if (innerRenderer || iconDataIndex) {
      const innerText = iconTuple[2];
      const fakeColInfo = {
        renderer: innerRenderer ?? '', // fallsback to just the value if there is no inner renderer
        classes: [],
      } as unknown as ConfigurableGridConfigItem;
      const renderedValue = Renderer.renderJustValue(innerText, fakeColInfo);
      const iconLeft = iconPosition === 'left';
      return (
        <span>
          {iconLeft ? iconElement : null}
          {renderedValue}
          {iconLeft ? null : iconElement}
        </span>
      );
    } else {
      return iconElement;
    }
  }
}

export class StatusIconRenderer extends React.Component<Params> {
  constructor(props: Params) {
    super(props);
  }

  render() {
    const { value: icon, rendererParams } = this.props;
    if (icon && typeof icon === 'string') {
      const fakeTuple = icon.split(',');
      const iconElement = <i className={`${statusClass} fa-fw ${fakeTuple[0]}`} style={{ color: fakeTuple[1] }} />;

      if (rendererParams?.innerRenderer) {
        const innerText = fakeTuple[2];
        const fakeColInfo = {
          renderer: rendererParams.innerRenderer,
          classes: [],
        } as unknown as ConfigurableGridConfigItem;
        const renderedValue = Renderer.renderJustValue(innerText, fakeColInfo);
        const iconLeft = rendererParams.iconPosition === 'left';
        return (
          <span>
            {iconLeft ? iconElement : null}
            {renderedValue}
            {iconLeft ? null : iconElement}
          </span>
        );
      }

      return iconElement;
    }
    return <></>;
  }
}
